export enum OptionNames {
  Seamless = 'Бесшовное полотно',
  StandartSizes = 'Стандартные панели',
  NotStandartSizes = 'Нестандартные размеры',
  Signature = 'Подпись художника',
  Varnish = 'Покрытие лаком',
  Install = 'Монтаж',
  Example = 'Образец',
  // Examples = 'Образцы',
  ShowJoints = 'Показать стыки',
  ToMirror = 'Отзеркалить',
  Urgency = 'Срочность',
  ThreeDimensionImage = 'Объемный рисунок'
}

export enum ColorPickersNames {
  Standart = 'Стандарт',
  Pearl = 'Перламутр',
  SilkNatural = 'Натуральный шёлк',
  SilkWild = 'Дикий шёлк',
  Texture = 'Текстура',
  Potal = 'Поталь',
  Shine = 'Shine',
  Sand = 'Sand',
  FabricSilk = 'Fabric silk',
  NaturalSilk = 'Natural silk',
}

export enum CategoryNames {
  Classic = 'CLASSIC',
  Geo = 'GEO',
  Pr = 'PR',
}

export enum ModeNames {
  Handmode = 'handMode',
  Panels = 'panels',
}
